import { Routes } from '@angular/router';
import { ECapabilities } from '@okcargo-apps/shared-domain-ionic';
import { authGuard } from './auth/application/auth.guard';
import { loginGuard } from './auth/application/login.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./layout/pages/tabs/tabs.routes').then((m) => m.routes),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.AUTHENTICATED },
  },
  {
    path: 'account',
    loadComponent: () => import('./layout/pages/account/account.page').then((m) => m.AccountPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.AUTHENTICATED },
  },
  {
    path: 'account/account-preferences',
    loadComponent: () =>
      import('./layout/pages/account-preferences/account-preferences.page').then((m) => m.AccountPreferencesPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.AUTHENTICATED },
  },
  {
    path: 'account/password',
    loadComponent: () => import('./layout/pages/password/password.page').then((m) => m.PasswordPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.AUTHENTICATED },
  },
  {
    path: 'my-company',
    loadComponent: () => import('./layout/pages/my-company/my-company.page').then((m) => m.MyCompanyPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.ADMINISTRATIVE_DOCUMENTS },
  },
  {
    path: 'billing-shipper',
    loadComponent: () =>
      import('./layout/pages/billing-shipper/billing-shipper.page').then((m) => m.BillingShipperPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.ADMINISTRATIVE_DOCUMENTS },
  },
  {
    path: 'posted-freight',
    loadComponent: () => import('./layout/pages/freight-posted/freight-posted.page').then((m) => m.FreightPostedPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.UPLOAD_FREIGHTS },
  },
  {
    path: 'posted-freight/ship-new',
    loadComponent: () =>
      import('./layout/pages/freight-ship-new/freight-ship-new.page').then((m) => m.FreightShipNewPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.UPLOAD_FREIGHTS },
  },
  {
    path: 'posted-freight/ship-edit/:id',
    loadComponent: () =>
      import('./layout/pages/freight-ship-edit/freight-ship-edit.page').then((m) => m.FreightShipEditPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.UPLOAD_FREIGHTS },
  },
  {
    path: 'posted-freight/:id',
    loadComponent: () =>
      import('./layout/pages/freight-posted-detail/freight-posted-detail.page').then((m) => m.FreightPostedDetailPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.UPLOAD_FREIGHTS },
  },
  {
    path: 'vehicles',
    loadComponent: () => import('./layout/pages/vehicles/vehicles.page').then((m) => m.VehiclesPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.CRUD_VEHICLES },
  },
  {
    path: 'users',
    loadComponent: () => import('./layout/pages/users/users.page').then((m) => m.UsersPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.CRUD_USERS },
  },
  {
    path: 'help',
    loadComponent: () => import('./layout/pages/help/help.page').then((m) => m.HelpPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.AUTHENTICATED },
  },
  {
    path: 'sustainability',
    loadComponent: () => import('./layout/pages/sustainability/sustainability.page').then((m) => m.SustainabilityPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.UPLOAD_FREIGHTS },
  },
  {
    path: 'support',
    loadComponent: () => import('./layout/pages/support/support.page').then((m) => m.SupportPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.AUTHENTICATED },
  },
  {
    path: 'login',
    loadComponent: () => import('./layout/pages/login/login.page').then((m) => m.LoginPage),
    canActivate: [loginGuard],
  },
  {
    path: 'recover-password',
    loadComponent: () =>
      import('./layout/pages/recover-password/recover-password.page').then((m) => m.RecoverPasswordPage),
    canActivate: [loginGuard],
  },
  {
    path: 'recover-password-confirm',
    loadComponent: () =>
      import('./layout/pages/recover-password-confirm/recover-password-confirm.page').then(
        (m) => m.RecoverPasswordConfirmPage,
      ),
    canActivate: [loginGuard],
  },
  {
    path: 'error',
    loadComponent: () => import('./layout/pages/error/error.page').then((m) => m.ErrorPage),
  },
  {
    path: 'update-required',
    loadComponent: () =>
      import('./layout/pages/update-required/update-required.page').then((m) => m.UpdateRequiredPage),
  },
  // catch all
  { path: '**', redirectTo: '/', pathMatch: 'full' },
];
